import React, {useEffect} from 'react';
import { graphql } from 'gatsby';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { handleOmButtonClick } from './forms/OmButton';
import { OmRefinedPromoBanner } from '@om/component-library-react';
import { getIsFormOpenAndPrepopulated} from '@om/redux/selectors/publicWeb/callMeBack';

const RefinedPromoBannerV2 = ({ refinedPromoBannerContent }) => {
    const dispatch = useDispatch();
    
    let cmbData;

    if(refinedPromoBannerContent){
        cmbData = refinedPromoBannerContent.button;
    }

    const {
        isPrepopulatedCmb
    } = useSelector(
        createStructuredSelector({
            isPrepopulatedCmb: getIsFormOpenAndPrepopulated,

        })
    );

    useEffect(() => {
        if(isPrepopulatedCmb && cmbData)
            handleOmButtonClick(cmbData, dispatch, isPrepopulatedCmb, 'RefinedPromoBannerV2');
    }, [
        isPrepopulatedCmb,
        cmbData
    ]);

    if (!refinedPromoBannerContent) {
        return '';
    }
    const {
        uid,
        has_boundary,
        img_url,
        button,
        top_line,
        use_heading_as_h1,
        heading,
        sub_title,
        put_text_on_the_right_of_image,
        caption,
        top_text_slot,
        main_text_slot,
        top_text_slot_mobile,
        main_text_slot_mobile,
    } = refinedPromoBannerContent;

    return (
        <section>
            <OmRefinedPromoBanner
                id={uid}
                hasBoundary={has_boundary}
                imgUrl={img_url ? img_url.url : ''}
                buttonText={button && button.display_text}
                onButtonAction={e => {
                    handleOmButtonClick(e, dispatch, isPrepopulatedCmb);
                }}
                buttonActionObject={
                    button && button.action && JSON.stringify(button.action[0])
                }
                topLine={top_line ? top_line : ''}
                putTextRight={
                    put_text_on_the_right_of_image ? 'switch-right' : ''
                }
            >
                {top_line ? (
                    <span
                        slot='top-line'
                        dangerouslySetInnerHTML={{ __html: top_line }}
                    />
                ) : (
                    ''
                )}
                {heading ? (
                    use_heading_as_h1 ? (
                        <h1
                            slot='heading'
                            dangerouslySetInnerHTML={{ __html: heading }}
                        />
                    ) : (
                        <span
                            slot='heading'
                            dangerouslySetInnerHTML={{ __html: heading }}
                        />
                    )
                ) : (
                    ''
                )}
                {sub_title ? (
                    <span
                        slot='sub-title'
                        dangerouslySetInnerHTML={{ __html: sub_title }}
                    />
                ) : (
                    ''
                )}
                {caption ? (
                    <span
                        slot='caption'
                        dangerouslySetInnerHTML={{ __html: caption }}
                    />
                ) : (
                    ''
                )}
                {img_url ? (
                    <React.Fragment>
                        <div
                            slot='promo-image-desktop'
                            className={`lazy-background ${
                                put_text_on_the_right_of_image
                                    ? 'switch-right'
                                    : ''
                            }`}
                            style={{ backgroundImage: `url('${img_url.url}')` }}
                        />
                        <div
                            slot='promo-image-mobile'
                            className='lazy-background'
                            style={{ backgroundImage: `url('${img_url.url}')` }}
                        />
                    </React.Fragment>
                ) : (
                    ''
                )}
                {top_text_slot ? (
                    <span
                        slot='top-text-slot'
                        dangerouslySetInnerHTML={{ __html: top_text_slot }}
                    />
                ) : (
                    ''
                )}
                {main_text_slot ? (
                    <span
                        slot='main-text-slot'
                        dangerouslySetInnerHTML={{ __html: main_text_slot }}
                    />
                ) : (
                    ''
                )}
                {top_text_slot_mobile ? (
                    <span
                        slot='top-text-slot-mobile'
                        dangerouslySetInnerHTML={{
                            __html: top_text_slot_mobile,
                        }}
                    />
                ) : (
                    ''
                )}
                {main_text_slot_mobile ? (
                    <span
                        slot='main-text-slot-mobile'
                        dangerouslySetInnerHTML={{
                            __html: main_text_slot_mobile,
                        }}
                    />
                ) : (
                    ''
                )}
            </OmRefinedPromoBanner>
        </section>
    );
};

export const pageQuery = graphql`
    fragment RefinedPromoBannerV2 on Contentstack_refined_promo_banner_v2 {
        uid
        has_boundary
        use_heading_as_h1
        top_line
        heading
        sub_title
        caption
        img_url {
            ...File
        }
        button {
            ...RefinedPromoBannerButton
        }
        top_text_slot
        top_text_slot_mobile
        main_text_slot
        main_text_slot_mobile
        put_text_on_the_right_of_image
    }
`;

export default RefinedPromoBannerV2;
